Wee.fn.make('dropdowns', {
	init: function() {
		var priv = this.$private,
			dropRef = 'ref:weeDropdown';

		if (Wee.$contains('ref:stateForm', dropRef)) {
			this.dropdowns = new Wee.fn.dropdown();
			priv.createDropdown($(dropRef));
			priv.monitorForm();
			priv.disableBodyScroll();
		}
	},
	unload: function() {
		if (this.dropdowns) {
			this.dropdowns.$destroy;
		}

		$.events.off(false, '.dropdownScroll');
	}
}, {
	/**
	 * Create dropdown element
	 *
	 * @private
	 */
	createDropdown: function(dropdown) {
		var stateTarget;

		this.$public
			.dropdowns
			.init({
				rootModifier: dropdown.data('modifier'),
				search: true,
				itemSelect: function(option) {
					stateTarget = option.value;
					Wee.$data('ref:dropdownGo', 'target', stateTarget);
				}
			});
	},

	/**
	 * Monitor state dropdown form for navigation
	 *
	 * @private
	 */
	monitorForm: function() {
		Wee.events.on('ref:stateForm', 'submit', function(e) {
			var target = Wee.$data('ref:dropdownGo', 'target');

			Wee.history.go({
				path: target ? '/' + target : '/locations'
			});

			e.preventDefault();
		});
	},

	/**
	 * Disable body scroll when scrolling inside dropdown content
	 *
	 * @private
	 */
	disableBodyScroll: function() {
		var $body = $($._body),
			noScroll = '-no-scroll';

		$.events.on({
			'ref:dropdownContent': {
				'mouseenter': function() {
					$body.addClass(noScroll);
				},
				'mouseleave': function() {
					$body.removeClass(noScroll);
				}
			}
		}, {
			namespace: 'dropdownScroll'
		});
	}
});